import { ReleaseEntityV1alpha1 } from '@agilelab/plugin-wb-builder-common';
import { Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { FC, useMemo } from 'react';
import { entitySupportsReverseProvisioning } from '../../../utils';
import { EditButton } from '../../common';
import { useEditorPageContext } from '../context/useEditorPageContext';
import { NewSnapshotButton } from '../NewSnapshotButton';
import { UpdateButton } from '../UpdateButton';
import ImportButton from './ImportButton';

export const EditorCardActions: FC = () => {
  const {
    entity,
    releases,
    fetchReleaseState,
    parent,
    descriptorStateWithComponents,
  } = useEditorPageContext();
  const showImport = entitySupportsReverseProvisioning(entity);

  // snapshot creation is disabled if there is already a snapshot
  const snapshot = useMemo(() => {
    return releases?.find((r: ReleaseEntityV1alpha1) => r?.metadata.isSnapshot);
  }, [releases]);

  return (
    <Box display="flex" alignItems="center">
      <Box display="flex" alignItems="center" style={{ gap: '8px' }}>
        {fetchReleaseState.loading ? (
          <Skeleton width={100} />
        ) : (
          <>
            {showImport && (
              <ImportButton
                entity={entity}
                disabled={descriptorStateWithComponents.loading}
              />
            )}
            <EditButton
              entity={entity}
              variant="outlined"
              disabled={descriptorStateWithComponents.loading}
            />
            {!parent && (!snapshot ? <NewSnapshotButton /> : <UpdateButton />)}
          </>
        )}
      </Box>
    </Box>
  );
};
